import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppLayout } from '../../components/layout/AppLayout';

export const Route = createFileRoute('/_static')({
	component: StaticLayout,
});

function StaticLayout() {
	return (
		<AppLayout restrictScroll={false}>
			<Outlet />
		</AppLayout>
	);
}
